<template>
    <InfoModal
        :info="info"
        :illustrationPath="illustrationPath"
    />
</template>

<script>
    import InfoModal from '@app/modals/modals/InfoModal';

    export default {
        name: 'TicketNotFound',
        data() {
            return {
                info: 'Your ticket does not exist, check if ID is correct',
                illustrationPath: '/static/img/illustrations/ticket__check-error.svg',
            };
        },
        components: {
            InfoModal
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/singleTicket/TicketNotFound.vue